import ShowLess from "../../partials/ShowLess";
import { FC } from "react";
import styles from "./lidarseg.module.scss";
import lidarSegChart from "../../assets/images/panoptic-chart.png";
import { contactEmail } from "../../shared";

const Lidarseg: FC = () => (
  <ShowLess>
    <section className={`content pb-2em text-justify ${styles.content}`}>
      <p>
        In the first nuScenes release, bounding boxes or cuboids are used to
        represent 3D objects. While useful in many cases, cuboids lack the
        ability to capture fine shape details of articulated objects. Panoptic
        nuScenes has higher levels of granularity by containing annotations for
        every single lidar point in the 40,000 keyframes of the nuScenes
        dataset. An astonishing 1,400,000,000 lidar points are each annotated
        with a semantic label, an instance label, and a track label.
      </p>
      <p>
        The semantic label can be one of 32 classes. In addition to the 23
        foreground classes (things) from nuScenes, we have included 9 background
        classes (stuff). For a detailed definition of every class and example
        images, please see the annotator instructions{" "}
        <a
          href="https://github.com/nutonomy/nuscenes-devkit/blob/master/docs/instructions_nuscenes.md"
          target="_blank"
          rel="noreferrer noopener"
        >
          here
        </a>{" "}
        and{" "}
        <a
          href="https://github.com/nutonomy/nuscenes-devkit/blob/master/docs/instructions_lidarseg.md"
          target="_blank"
          rel="noreferrer noopener"
        >
          here
        </a>
        .
      </p>
      <p>
        The taxonomy of Panoptic nuScenes is compatible with the rest of
        nuScenes and nuImages, thus enabling a wide range of research across
        multiple sensor modalities. This is a major step forward for industry
        and academia alike, as it allows researchers to study and quantify novel
        problems such as lidar point cloud segmentation, foreground extraction,
        sensor calibration and mapping using point-level semantics. In the
        future, we plan to organize various public challenges around these
        tasks.
      </p>
      <p>
        Panoptic nuScenes is standing on the shoulders of giants. The academic{" "}
        <a
          href="http://semantic-kitti.org/"
          target="_blank"
          rel="noreferrer noopener"
        >
          SemanticKITTI
        </a>{" "}
        dataset annotates the famous KITTI dataset with lidar segmentation
        labels for 28 classes. KITTI primarily consists of suburban streets with
        low traffic density and less challenging traffic situations. Its
        annotations only cover the front camera, rather than the entire 360
        degree view. Furthermore it does not contain radar and is strictly for
        non-commercial use. nuScenes set out to improve on these aspects,
        featuring dense data from urban and suburban scenes in Singapore and
        Boston. It is a multimodal dataset that covers the entire 360 degree
        view and can be licensed by commercial entities. Following the launch of
        Panoptic nuScenes (of which the lidar semantic segmentation annotations
        were initially released as nuScenes-lidarseg in October 2019), we have
        seen a number of other lidar segmentation datasets emerge, such as
        Hesai's Pandaset and we are looking forward to more companies sharing
        their data with the community.
      </p>
      <p>
        Just like nuScenes, the Panoptic nuScenes annotations are available as
        free to use strictly for non-commercial purposes. Non-commercial means
        not primarily intended for or directed towards commercial advantage or
        monetary compensation. Examples of non-commercial use include but are
        not limited to personal use, educational use, such as in schools,
        academies, universities etc., and some research use. If you intend to
        use the nuScenes dataset for commercial purposes, we encourage you to
        contact us for commercial licensing options by sending an email to{" "}
        <a href={`mailto:${contactEmail}`}>{contactEmail}</a>.
      </p>
      <div className={styles.figure}>
        <p>
          We hope that this dataset will allow researchers across the world to
          go even further in the quest to develop safe autonomous driving
          technology.
        </p>
        <div className={styles.chart}>
          <img src={lidarSegChart} alt="chart" />
        </div>
      </div>
    </section>
  </ShowLess>
);

export default Lidarseg;
